import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFigmaS = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 6V10M12 6H10C8.89543 6 8 6.89543 8 8C8 9.10457 8.89543 10 10 10H12M12 6H14C15.1046 6 16 6.89543 16 8C16 9.10457 15.1046 10 14 10H12",
			stroke: "white",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 16V14H10C8.89543 14 8 14.8954 8 16C8 17.1046 8.89543 18 10 18C11.1046 18 12 17.1046 12 16Z",
			stroke: "white",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 10V14M12 10H10C8.89543 10 8 10.8954 8 12C8 13.1046 8.89543 14 10 14H12M12 10H14C15.1046 10 16 10.8954 16 12C16 13.1046 15.1046 14 14 14H12",
			stroke: "white",
			strokeWidth: 2
		})
	]
});
export default SvgFigmaS;
